import React, { Component } from "react";
import Detail from "./view/Detail.js";
import List from "./view/List.js";
import ViewModel from "./controllers/ViewModel.js";
import SubHeader from "../header/SubHeaderView.js";
import ExcelList from "./view/Excel.js";

export default class CorridasAndamento extends Component {
  constructor(props) {
    super(props);
    this.viewModel = new ViewModel();
    this.viewModel.mirrorState = (s) => this.setState(s);
    this.viewModel.props = props;
  }

  componentDidMount() {
    this.viewModel.fetchData();
  }

  render() {
    return (
      <div className="page-content-wrapper">
        <SubHeader textoEsquerda="Corridas Em Andamento" textoCentral="Corridas" />
        <div className="page-content">
          <div className="container">

          <div className="rowAjust">
            {this.viewModel.state.showModal && (
              <Detail {...this.props} viewModel={this.viewModel} />
            )}
            <List {...this.props} viewModel={this.viewModel} />
            
            <ExcelList {...this.props} file={"corridas_em_andamento"}  viewModel={this.viewModel} title="Corridas Em Andamento" configs={[
              { label: "No.", value: "t12_num_corrida" },
              { label: "Data Corrida", value: "t12_dthr_corrida" },
              { label: "Passageiro", value: "t12_nome" },
              { label: "Endereço", value: "t12_endereco" },
              { label: "Valor", value: "valorcalculado" },
              { label: "Status", value: "ztatus3" },
              { label: "Centro de custo", value: "voucher_departamento_identificacao" },
              { label: "Descrição", value: "voucher_departamento_descricao" },
            ]} />
          </div></div>
        </div>
      </div>
    );
  }
}
